import { render, staticRenderFns } from "./faq-page.vue?vue&type=template&id=3eaf5c6e&scoped=true&lang=pug&"
import script from "./faq-page.vue?vue&type=script&lang=js&"
export * from "./faq-page.vue?vue&type=script&lang=js&"
import style0 from "./faq-page.vue?vue&type=style&index=0&id=3eaf5c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf5c6e",
  null
  
)

export default component.exports